import { render, staticRenderFns } from "./LinkBtnIcon.vue?vue&type=template&id=6b5b4303&scoped=true"
import script from "./LinkBtnIcon.vue?vue&type=script&lang=js"
export * from "./LinkBtnIcon.vue?vue&type=script&lang=js"
import style0 from "./LinkBtnIcon.vue?vue&type=style&index=0&id=6b5b4303&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5b4303",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonIcon: require('/builds/marketing/abstracta.academy-website/components/ButtonIcon.vue').default})
